import apiClient from './config'

/**
 * 认证相关API服务
 */
export const authAPI = {
  /**
   * 管理员登录
   * @param {Object} credentials - 登录凭据
   * @param {string} credentials.username - 用户名
   * @param {string} credentials.password - 密码
   * @returns {Promise} 登录结果
   */
  async login(credentials) {
    try {
      const response = await apiClient.post('/auth/login', credentials)
      
      // 保存token到localStorage
      if (response.token) {
        localStorage.setItem('token', response.token)
      }
      
      return response
    } catch (error) {
      console.error('登录失败:', error.message)
      throw error
    }
  },

  /**
   * 获取当前管理员信息
   * @returns {Promise} 管理员信息
   */
  async getCurrentAdmin() {
    try {
      const response = await apiClient.get('/auth/admin')
      return response
    } catch (error) {
      console.error('获取管理员信息失败:', error.message)
      throw error
    }
  },

  /**
   * 修改管理员密码
   * @param {Object} passwordData - 密码数据
   * @param {string} passwordData.current_password - 当前密码
   * @param {string} passwordData.new_password - 新密码
   * @returns {Promise} 修改结果
   */
  async changePassword(passwordData) {
    try {
      const response = await apiClient.post('/auth/change-password', passwordData)
      return response
    } catch (error) {
      console.error('修改密码失败:', error.message)
      throw error
    }
  },

  /**
   * 验证token有效性
   * @returns {Promise} 验证结果
   */
  async verifyToken() {
    try {
      const response = await apiClient.get('/auth/verify')
      return response
    } catch (error) {
      console.error('Token验证失败:', error.message)
      throw error
    }
  },

  /**
   * 登出
   * 清除本地存储的认证信息
   */
  logout() {
    localStorage.removeItem('token')
    localStorage.removeItem('user')
    localStorage.removeItem('rememberPassword')
    localStorage.removeItem('savedCredentials')
  }
}

export default authAPI